import { Badge, Box, Checkbox, FieldAlert } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import styles from './eventPicker.module.scss';

export type EventPickerProps = {
  events: string[];
  input: { value: string[]; onChange: (events: string[]) => void };
  meta: { error?: string; submitFailed: boolean };
};

export function EventPicker({
  events,
  input,
  meta,
}: EventPickerProps): JSX.Element {
  const isCheckedAll =
    events.length > 0 && events.length === input.value.length;

  const showError = meta.error && meta.submitFailed;

  const onSelectAll = () => {
    if (isCheckedAll) {
      input.onChange([]);
    } else {
      input.onChange(events.slice());
    }
  };

  const readableEventName = (event: string) => {
    const newEvent = event.split('_').slice(1).join(' ').toLowerCase();
    return newEvent.charAt(0).toUpperCase() + newEvent.slice(1);
  };

  return (
    <>
      <Box
        className={classnames(styles.container, {
          [styles.containerBorder]: showError,
        })}
      >
        <div className={styles.header}>
          <label className={styles.title}>
            <Checkbox
              id="event_picker_all"
              name="event_picker_all"
              className={styles.checkbox}
              checked={isCheckedAll}
              onChange={onSelectAll}
            />
            Select all events
            {input.value?.length > 0 && (
              <Badge
                className={styles.titleBadge}
                size="small"
                variant="secondary"
              >
                {input.value.length}
              </Badge>
            )}
          </label>
        </div>
        <div className={styles.body}>
          {events.map((event) => (
            <div key={event} className={styles.bodyItem}>
              <label>
                <Checkbox
                  name={event}
                  className={styles.checkbox}
                  checked={input.value.includes(event)}
                  onChange={() => {
                    input.onChange(
                      input.value.includes(event)
                        ? input.value.filter((item) => item !== event)
                        : [...input.value, event],
                    );
                  }}
                />
                {readableEventName(event)}
              </label>
            </div>
          ))}
        </div>
      </Box>
      {showError && (
        <FieldAlert className={styles.errorMessage} variant="error">
          {meta.error}
        </FieldAlert>
      )}
    </>
  );
}
